export const PORTFOLIO_CALENDAR_CONFIG = {
    name            : 'Calendar',
    menuName        : 'Calendar',
    icon            : 'i5-calendar',
    // iconLight       : 'i5-calendar-light',
    image           : 'calendar',
    iconSvg         : 'isvg-view-calendar',
    url             : 'calendar',
    stringId        : 'calendar',
    description     : 'Monthly/Weekly Calendar displaying events, milestones, and deadlines.'
}
